var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar-plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33333 1.33331C5.70152 1.33331 6 1.63179 6 1.99998V2.66665L10 2.66665V1.99998C10 1.63179 10.2985 1.33331 10.6667 1.33331C11.0349 1.33331 11.3333 1.63179 11.3333 1.99998V2.66665L12 2.66665C13.1046 2.66665 14 3.56208 14 4.66665L14 12.6666C14 13.7712 13.1046 14.6666 12 14.6666L4 14.6666C2.89543 14.6666 2 13.7712 2 12.6666L2 4.66665C2 3.56208 2.89543 2.66665 4 2.66665H4.66667V1.99998C4.66667 1.63179 4.96514 1.33331 5.33333 1.33331ZM4.66667 3.99998H4C3.63181 3.99998 3.33333 4.29846 3.33333 4.66665L3.33333 6.66665L12.6667 6.66665V4.66665C12.6667 4.29846 12.3682 3.99998 12 3.99998H11.3333V4.66665C11.3333 5.03484 11.0349 5.33331 10.6667 5.33331C10.2985 5.33331 10 5.03484 10 4.66665V3.99998L6 3.99998V4.66665C6 5.03484 5.70152 5.33331 5.33333 5.33331C4.96514 5.33331 4.66667 5.03484 4.66667 4.66665V3.99998ZM12.6667 7.99998L3.33333 7.99998L3.33333 12.6666C3.33333 13.0348 3.63181 13.3333 4 13.3333L12 13.3333C12.3682 13.3333 12.6667 13.0348 12.6667 12.6666L12.6667 7.99998ZM8 8.66665C8.36819 8.66665 8.66667 8.96512 8.66667 9.33331V9.99998L9.33333 9.99998C9.70152 9.99998 10 10.2985 10 10.6666C10 11.0348 9.70152 11.3333 9.33333 11.3333L8.66667 11.3333V12C8.66667 12.3682 8.36819 12.6666 8 12.6666C7.63181 12.6666 7.33333 12.3682 7.33333 12V11.3333H6.66667C6.29848 11.3333 6 11.0348 6 10.6666C6 10.2985 6.29848 9.99998 6.66667 9.99998H7.33333V9.33331C7.33333 8.96512 7.63181 8.66665 8 8.66665Z",
    fill: "white",
    fillOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.2a99fa97a0813d52a91769d2dc942bd6.svg";
export { ForwardRef as ReactComponent };